export enum ProgramRequestSort {
    ProgramRequestDate = 1,
    InstitutionName = 2,
    ProgramName = 3,
    ProgramTypeName = 4,
    ProgramRequestStatusInstitution = 5,
    ProgramRequestStatusMinistry = 6,
    ClassificationMark = 7,
    EducationSector = 8
}